module.exports = __webpack_public_path__ + "static/media/TPCDELUXESILVER.5696f260.jpg";